module.exports = __webpack_public_path__ + "img/主要功能-开放平台2.4aab81a6.png";